import React, { useEffect } from "react";
import { useGarmentMeasurementServiceContext } from "../../../../contexts/GarmentMeasurementServiceContext";
import GarmentMeasurementServiceImageList from "../GarmentMeasurementServiceImageList";
import { useMainScroll } from "../../../../contexts/MainScrollContext";

const Processing: React.FC = () => {
  const { submitMeasurement, uploadedImages, processingStatus, canProceedToNextStep, handlePageChange } = useGarmentMeasurementServiceContext();

  const { scrollToTop } = useMainScroll();

  useEffect(() => {
    scrollToTop();

    const isProcessingInProgress = Object.values(processingStatus).some((status) => status === "processing");

    const shouldStartMeasurement = !isProcessingInProgress && (Object.keys(processingStatus).length === 0 || Object.values(processingStatus).every((status) => status === "pending"));

    if (shouldStartMeasurement) {
      submitMeasurement();
    }
  }, []);

  useEffect(() => {
    if (canProceedToNextStep) {
      handlePageChange(2);
    }
  }, [canProceedToNextStep]);

  const validImages = uploadedImages.filter((img) => img !== "");
  const totalImages = validImages.length;

  const processedImages = Object.values(processingStatus).filter((status) => status === "success").length;
  const failedImages = Object.values(processingStatus).filter((status) => status === "error").length;
  const processingImages = Object.values(processingStatus).filter((status) => status === "processing").length;

  const progress = totalImages > 0 ? Math.round(((processedImages + failedImages) / totalImages) * 100) : 0;

  return (
    <div className="flex flex-col items-center w-full gap-8 md:gap-16">
      {/* <FreeTrialServicesLoader /> */}

      <div className="flex flex-col items-center w-full gap-6">
        <span className="font-bold text-center capitalize text-closed-shutter-300">Processing images...</span>

        <div className="w-full max-w-md px-4">
          <div className="flex flex-col gap-4 p-4 border rounded-lg border-gorgonzola-blue-50">
            <div className="flex justify-between">
              <span className="text-sm text-gorgonzola-blue-600">Progress</span>
              <span className="text-xs font-medium text-gorgonzola-blue-800">{progress}%</span>
            </div>

            <div className="w-full h-2 overflow-hidden rounded-full bg-gorgonzola-blue-50">
              <div className="h-full transition-all duration-300 ease-in-out bg-gorgonzola-blue-400" style={{ width: `${progress}%` }}></div>
            </div>

            <div className="grid grid-cols-2 gap-2">
              <div className="flex flex-col">
                <span className="text-xs text-gorgonzola-blue-400">Total Images</span>
                <span className="font-medium text-gorgonzola-blue-700">{totalImages}</span>
              </div>
              <div className="flex flex-col">
                <span className="text-xs text-gorgonzola-blue-400">Processed</span>
                <span className="font-medium text-gorgonzola-blue-700">{processedImages}</span>
              </div>
              <div className="flex flex-col">
                <span className="text-xs text-gorgonzola-blue-400">Processing</span>
                <span className="font-medium text-gorgonzola-blue-700">{processingImages}</span>
              </div>
              <div className="flex flex-col">
                <span className="text-xs text-english-vermillion-400">Failed</span>
                <span className="font-medium text-english-vermillion-600">{failedImages}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full max-w-5xl px-4">
          <div className="flex flex-col w-full border divide-y rounded-lg border-gorgonzola-blue-50 divide-gorgonzola-blue-50">
            <h3 className="p-4 text-closed-shutter-300">Images Status</h3>
            <div className="p-4">
              <GarmentMeasurementServiceImageList />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Processing;
